import '../misc/NotFound.css';

function NotFound() {


   

    return (
        <div className='notfound-content'>
            <h1>404 Page not found <br></br>
            Sorry, the page you are looking for does not exist.</h1>
        </div>
    );
}

export default NotFound;
